import {createAction} from 'redux-actions';
import {actionTypes as system} from '../System';
import {handleActions} from '../../Utility/HandleActions';

const DEFAULTS = {
    groups: ['majors'],
    ccyPairs: []
}

const isValid = (spotOptions) => {
    return spotOptions && spotOptions.groups && spotOptions.ccyPairs;
}

const CHANGE_SPOT_OPTIONS = 'DBM/UI/SPOT/CHANGE_OPTIONS';
const ADD_CCY_PAIR = 'DBM/UI/SPOT/ADD_CCY_PAIR';

export const actionTypes = {
    CHANGE_SPOT_OPTIONS,
    ADD_CCY_PAIR
};

const changeSpotOptions = createAction(CHANGE_SPOT_OPTIONS, spotOptions => ({spotOptions}));
const addCcyPair = createAction(ADD_CCY_PAIR, ccyPair => ({ccyPair}));

const getSpotOptions = (state) => state.getIn(['ui', 'spot', 'options']);

export const actions = {
    changeSpotOptions,
    addCcyPair
};

export const selectors = {
    getSpotOptions
};

export const reducer = handleActions({
    [system.INIT]: () =>
        (state) => {
            return state.setIn(['ui', 'spot', 'options'], DEFAULTS);
        }
    ,

    [CHANGE_SPOT_OPTIONS]: (payload) =>
        (state) => {
            if (isValid(payload.spotOptions)) {
                return state.setIn(['ui', 'spot', 'options'], payload.spotOptions);
            } else {
                return state.setIn(['ui', 'spot', 'options'], DEFAULTS);
            }
        }
    ,
    [ADD_CCY_PAIR]: (payload) =>
        (state) => {
            const spotOptions = getSpotOptions(state);
            const newCcyPairs = [...spotOptions.ccyPairs, payload.ccyPair];
            const newSpotOptions = { ...spotOptions, ccyPairs: newCcyPairs };

            return state.setIn(['ui', 'spot', 'options'], newSpotOptions);
        }
});